import { useEffect } from 'react';
import useCallbackRef from 'hooks/useCallbackRef';

/**
 * Add a (global) event listener to your component.
 *
 * @param {string} eventName - Name of the event, e.g. 'click', or 'keydown'
 * @param {Function} callback - Function to run when the event occurs. Is called with the event object.
 * @param {object} [options]
 * @param {bool} [options.isEnabled=true] - Set this to false to disable the event listener
 * @param {bool} [options.capture=false] - Enable to capture non-bubbling events (e.g. focus within)
 * @param {object} [options.targetElement=document] - HTML element the event listener should be attached to
 */

function useEventListener(eventName, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var callbackRef = useCallbackRef(callback);
  var _options$isEnabled = options.isEnabled,
    isEnabled = _options$isEnabled === void 0 ? true : _options$isEnabled,
    _options$capture = options.capture,
    capture = _options$capture === void 0 ? false : _options$capture,
    _options$targetElemen = options.targetElement,
    targetElement = _options$targetElemen === void 0 ? document : _options$targetElemen;
  useEffect(function () {
    var element = targetElement;
    var currentCallback = function currentCallback(event) {
      return callbackRef.current(event);
    };
    if (isEnabled) {
      element.addEventListener(eventName, currentCallback, capture);
    } else {
      element.removeEventListener(eventName, currentCallback, capture);
    }
    return function cleanUp() {
      element.removeEventListener(eventName, currentCallback, capture);
    };
  }, [callbackRef, isEnabled, eventName, targetElement, capture]);
}
export default useEventListener;